import { Grid, Typography } from "@material-ui/core";
import { useEffect, useReducer } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CustomAlert from "../../componentes/alerts/CustomAlert";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import InputField from "../../componentes/form-fields/InputField/InputField";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import SupplierControlService from "./SupplierControlService";
import DefaultChip from "../../componentes/chip/DefaultChip";
/**
 * Author : AndréK
 * 26/08/2022
*/

const columns = (t) => [
    { field: "id", visible: false },
    {
        field: "ddi",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="ddi" />;
        },
        flex: 0.1,
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="standard"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.ddi}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "ddd",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="ddd" />;
        },
        flex: 0.1,
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="standard"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.ddd}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "phone",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} name="phone" />;
        },
        flex: 0.4,
    },
    {
        field: "contact",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="contact" name="user"/>;
        },
        flex: 0.5,
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="grey"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.contact}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "status",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="status" />;
        },
        flex: 0.5,
        template: (props) => {
            return (
                <>
                    {props.status == 1 ? (
                        <IconSwitch name="active" />
                    ) : (
                        <IconSwitch name="canceled" />
                    )}
                </>
            );
        },
    },
];

export const SupplierPhone = ({ idSupplier }) => {
    const { t } = useTranslation();
    const { control } = useForm();
    const userId = sessionStorage.getItem("userId");

    const initialState = {
        id: 0,
        idSupplier: idSupplier,
        ddd: "",
        ddi: "",
        phone: "",
        contact: "",
        rows: [],
        loggedUserId: userId,
        status: 1,
        success: false,
        error: false,
    };

    function formatPhoneNumber(value) {
        value = value.replace(/\D/g, ''); // Remove tudo que não for número

        if (value.length > 5) {
            value = value.replace(/^(\d{5})(\d{0,4})/, '$1-$2'); // 9 ou 8 dígitos
        } else if (value.length > 4) {
            value = value.replace(/^(\d{4})(\d{0,4})/, '$1-$2'); // 8 dígitos ainda incompleto
        }

        return value.slice(0, 9 + 1); // Limita a 10 caracteres com o hífen
    }

    const reducer = (state, action) => {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case "clear":
                return initialState
            case 'success':
                return { ...state, success: true, error: false }
            case 'error':
                return { ...state, success: false, error: true }
            case 'close_alert':
                return { ...state, success: false, error: false }
            default:
                return new Error();
        }
    }

    const [state, dispatch] = useReducer(reducer, initialState);

    const { id, ddd, ddi, phone, contact, status } = state
    const { success, error, rows, ...data } = state

    const handleChange = ({ target: { name, value } }) => {
        if (name === 'phone')
        {
            const formatted = formatPhoneNumber(value);
            dispatch({ type: 'update', data: { [name]: value, phone: formatted } })
        }
        else
        {
            dispatch({ type: 'update', data: { [name]: value } })
        }
    }

    const handleSearch = () => {
        SupplierControlService
            .getSupplierPhone(data)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({ type: 'update', data: { rows: response.data } })
                }
            })
            .catch((e) => dispatch({ type: 'update', data: { rows: [] } }));
    }

    const canSave = () => phone !== "" && contact !== "";

    const handleSaveUpdate = () => {
        if (canSave()) {
            if (id) {
                SupplierControlService
                    .updateSupplierPhone(data)
                    .then((response) => {
                        if (response.status === 200) {
                            dispatch({ type: 'success' })
                            handleSearch();
                        }
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            }
            else {
                SupplierControlService
                    .createSupplierPhone(data)
                    .then((response) => {
                        if (response.status === 200) {
                            dispatch({ type: 'update', data: { success: true, error: false, id: response.data.id } })
                            handleSearch();
                        }
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            }
        } else {
            dispatch({ type: 'error' })
        }
    }

    const handleCellClick = (data) => {
        dispatch({
            type: 'update', data: {
                id: data.id,
                ddd: data.ddd,
                ddi: data.ddi,
                phone: data.phone,
                contact: data.contact,
                status: data.status,
            }
        })
    }

    useEffect(() => {
        handleSearch();
    }, [])


    return (
        <DefaultScreenAccordion
            isTab
            fields={
                <GridItemContainer>
                    <CustomAlert
                        success={success}
                        error={error}
                        handleCloseAlert={() => dispatch({ type: 'close_alert' })}
                    />
                    <GridInputRow>
                        <Grid item xs={12} sm={6} md={2}>
                            <InputField
                                name="ddi"
                                control={control}
                                defaultValue=""
                                onChange={handleChange}
                                value={ddi}
                                type={"number"}
                                inputProps={{maxLength: 3}}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <InputField
                                name="ddd"
                                control={control}
                                defaultValue=""
                                onChange={handleChange}
                                value={ddd}
                                type={"number"}
                                inputProps={{maxLedngth: 3}}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <InputField
                                iconLabelSwitch={<IconLabelSwitch fontSize="small" name="phone" />}
                                name="phone"
                                control={control}
                                defaultValue=""
                                onChange={handleChange}
                                value={phone}
                                inputProps={{ maxLength: 20 }}
                                error={error && phone === ""}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <InputField
                                iconLabelSwitch={
                                    <IconLabelSwitch name="user" labelName="contact" />
                                }
                                name="contact"
                                control={control}
                                defaultValue=""
                                onChange={handleChange}
                                value={contact}
                                inputProps={{ maxLength: 50 }}
                                error={error && contact === ""}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <DefaultAutocomplete
                                name={"status"}
                                onChange={handleChange}
                                value={status}
                                label={t("status")}
                                defaultSize
                                error={error && status === 2}
                                items={[
                                    { id: 0, name: t("canceled"), status: 1 },
                                    {id: 1, name: t("active"), status: 1},
                                    {id: 2, name: t("all"), status: 1},
                                ]}
                            />
                        </Grid>
                    </GridInputRow>
                    <SearchClearSaveRow
                        onClickSearch={handleSearch}
                        onClickClear={() => dispatch({ type: 'clear' })}
                        onClickSave={handleSaveUpdate}
                    />
                    {(rows.length > 0) ? (
                        <GridInputRow>
                            <Grid item xs={12}>
                                <DefaultDatagrid
                                    columns={columns(t)}
                                    dataSource={rows}
                                    allowPaging={true}
                                    cellSelected={(args, grid) =>
                                        handleCellClick(args.data)
                                    } />
                            </Grid>
                        </GridInputRow>
                    ) : null}
                </GridItemContainer>
            } />
    );
}